<template>
  <el-row justify="center" style="height: 100vh">
    <div
      :class="`body-view position-relative`"
      :style="{
        boxShadow: `var(--el-box-shadow-dark)`,
      }"
    >
      <router-view />
    </div>
  </el-row>
</template>

<script lang="ts" setup>
import { ref, watch, inject, onBeforeMount } from "vue";
import Storage from "@/core/config/Storage";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";

import { useRoute, useRouter } from "vue-router";
const route = useRoute();
const router = useRouter();

const { locale } = useI18n();
const store = useStore();
const setting = ref() as any;
// const style = ref("style-1");
const style = ref(route.path.includes("/s2") ? "style-3" : "style-1");

onBeforeMount(async () => {
  if (!window.location.pathname.includes("/play")) {
    Storage.setStyle(
      window.location.pathname.includes("/s") ? "style-3" : "style-1"
    );
  }

  document.body.classList.add(Storage.getStyle());

  let settingValue = store.getters["siteSetting/getList"].data;
  while (!settingValue) {
    await new Promise((resolve) => setTimeout(resolve, 100));
    settingValue = store.getters["siteSetting/getList"].data;
  }
  setting.value = settingValue;

  const lang = Storage.getLang();
  locale.value = lang === "en" || lang === "th" ? lang : "en";
  Storage.setLang(locale.value);
});
</script>

<style lang="scss">
.body-main {
  min-height: calc(100vh - var(--height-footer));
  margin-bottom: var(--height-footer);
}
</style>
